import idx from 'idx'
import { getProjectCategory } from '../actions/global-setting.action'
import {
  addUser as addUserAPI,
  deleteRole as deleteRoleAPI,
  deleteUser as deleteUserAPI,
  editUser as editUserAPI,
  editUserRole as editUserRoleAPI,
  forgetPassword as forgetPasswordAPI,
  getActiveUser as getActiveUserAPI,
  getRolesList as getRolesListAPI,
  getUser as getUserAPI,
  getUserData as getUserDataAPI,
  getUserList as getUserListApi,
  getUserNames as getUserNamesAPI,
  login as loginAPI,
  logout as logoutAPI,
  saveUserRole as saveUserRoleAPI,
  updatePassword as updatePasswordAPI,
  updateProfile as updateProfileAPI,
  updateUserRoles as updateUserRolesAPI,
  verifyPassword as verifyPasswordAPI
} from '../api/user-management.api'
import {
  REMOVE_USER_DATA,
  SAVE_USER_DATA
} from '../constants/action.constant'
import { listSubscriptions } from './subscription.action'

export const saveUserData = data => ({ type: SAVE_USER_DATA, data })

export const removeUserData = () => ({ type: REMOVE_USER_DATA })

export const getUserList = (params) => {
  return (dispatch, getState) => {
    return getUserListApi(params)
  }
}

export const saveUserRole = (data) => {
  return (dispatch, getState) => {
    return saveUserRoleAPI(data)
  }
}

export const editUserRole = (data, id) => {
  return (dispatch, getState) => {
    return editUserRoleAPI(data, id)
  }
}

export const addUser = (data) => {
  return (dispatch, getState) => {
    return addUserAPI(data)
  }
}

export const getRolesList = (data) => {
  return (dispatch, getState) => {
    return getRolesListAPI(data)
  }
}

export const login = (data) => {
  return (dispatch, getState) => {
    return loginAPI(data).then(async (response) => {
      let userDataResult = null;
      let userDataError = null;
      try {
        userDataResult = await dispatch(getUserData());
      } catch (err) {
        userDataError = err;
      }
      const finalState = getState();
      // Backward compatible: always return loginResponse as top-level property
      return {
        loginResponse: response,
        userData: userDataResult,
        userDataError,
        user: finalState.user,
        project: finalState.project,
        projectCategories: finalState.project?.projectCategories,
        projectType: finalState.project?.projectType,
        subscriptions: finalState.subscriptions,
        isLoggedIn: finalState.user?.isLoggedIn,
      };
    }).catch(e => {
      dispatch(removeUserData());
      // Backward compatible: return error in same structure
      return { loginResponse: null, error: e };
    });
  };
};

export const logout = ({ allDevices = false } = {}) => {
  return (dispatch) => {
    return logoutAPI({ allDevices: allDevices === true }).then(response => {
      // Clear Redux state
      dispatch(removeUserData())
      return response;
    }).catch(e => {
      dispatch(removeUserData())
    })
  }
}

export const getUserData = () => {
  return (dispatch, getState) => {
    return getUserDataAPI().then(async (response) => {
      // Dispatch user data
      dispatch(saveUserData(idx(response, _response => _response)))

      // Dispatch project categories
      const projectCategoryResult = await dispatch(getProjectCategory('PROJECTCATEGORIES'))

      // Dispatch subscriptions if global user
      let subscriptionResult = null;
      if (idx(response, _ => _.is_global) == 1) {
        subscriptionResult = await dispatch(listSubscriptions());
      }

      // Get final state after all dispatches
      const finalState = getState();

      // Return comprehensive data
      return {
        userData: idx(response, _response => _response),
        projectCategories: finalState.project?.projectCategories,
        subscriptions: finalState.subscriptions?.list,
        isGlobal: idx(response, _ => _.is_global),
        projectCategoryResult,
        subscriptionResult
      };
    }).catch((e) => {
      console.error('Get user data error:', e);
    })
  }
}

export const getUser = (id) => {
  return (dispatch, getState) => {
    return getUserAPI(id)
  }
}

export const deleteRole = (id) => {
  return (dispatch, getState) => {
    return deleteRoleAPI(id)
  }
}

export const updateProfile = (data) => {
  return (dispatch, getState) => {
    return updateProfileAPI(data)
  }
}

export const updatePassword = (data) => {
  return (dispatch, getState) => {
    return updatePasswordAPI(data)
      .then(response => {
        dispatch(getUserData())
        return response;
      }).catch(e => {
        dispatch(removeUserData())
      })
  }
}

export const editUser = (data, id) => {
  return (dispatch, getState) => {
    return editUserAPI(data, id)
  }
}

export const getUserNames = () => {
  return (dispatch, getState) => {
    return getUserNamesAPI()
  }
}

export const forgetPassword = (email) => {
  return (dispatch, getState) => {
    return forgetPasswordAPI({ email })
  }
}

export const deleteUser = (id) => {
  return (dispatch, getState) => {
    return deleteUserAPI(id)
  }
}

export const getActiveUser = () => {
  return (dispatch, getState) => {
    return getActiveUserAPI()
  }
}


export const updateUserRoles = (data, id) => {
  return (dispatch, getState) => {
    return updateUserRolesAPI(data, id)
  }
}

export const verifyPassword = (data) => {
  return (dispatch, getState) => {
    return verifyPasswordAPI({ password: data })
  }
}